import React, { useEffect, useState } from 'react';
import { BuyerOptionPresetGroupInfoEdit } from './BuyerOptionPresetGroupInfoEdit';
import { BuyerOptionPresetGroupInfoView } from './BuyerOptionPresetGroupInfoView';
import { OptionPresetGroupDto } from '@/services/option-preset/option-preset-group';

export interface BuyerOptionPresetGroupInfoProps {
    group: OptionPresetGroupDto;
    onSave(newValue: OptionPresetGroupDto): Promise<void>;
    onPresetUpdate?(): void;
}

export const BuyerOptionPresetGroupInfo: React.FC<BuyerOptionPresetGroupInfoProps> = ({ group, onSave, onPresetUpdate }) => {
    const [editValue, setEditValue] = useState<OptionPresetGroupDto | null>(null);

    useEffect(() => {
        setEditValue(null);
    }, [group]);

    const handleSave = async () => {
        if (!editValue) {
            return;
        }

        await onSave(editValue);
        setEditValue(null);
    };

    const handleCancel = () => {
        setEditValue(null);
    };

    if (editValue) {
        return (
            <BuyerOptionPresetGroupInfoEdit
                group={editValue}
                onChange={setEditValue}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        );
    }

    return <BuyerOptionPresetGroupInfoView group={group} onEditClick={() => setEditValue(group)} onPresetUpdate={onPresetUpdate} />;
};
